export const photos = [
    {
        src: 'website_photos/proposal4',
        title: '8 years by her side',
        location: 'Palace of Fine Arts, San Francisco',
        date: '2025',
    },
    {
        src: 'website_photos/proposal3',
        title: 'Surprise',
        location: 'Palace of Fine Arts, San Francisco',
        date: '2025',
    },
    {
        src: 'website_photos/proposal1',
        title: 'Started our Forever',
        location: 'Palace of Fine Arts, San Francisco',
        date: '2025',
    },
    {
        src: 'website_photos/proposal2',
        title: 'Love of my Life',
        location: 'Palace of Fine Arts, San Francisco',
        date: '2025',
    },
    {
        src: 'website_photos/pranay_wedding',
        title: "At Pranay & Arshiya's Wedding",
        location: 'Jaipur, Rajasthan',
        date: '2025',
    },
    {
        src: 'website_photos/mendocino1',
        title: 'California Coasts',
        location: 'Mendocino, California',
        date: '2025',
    },
    {
        src: 'website_photos/mumbai_skyline',
        title: 'Taj Mahal Palace & the Gateway of India',
        location: 'Mumbai',
        date: '2025',
    },
    {
        src: 'website_photos/akshardham',
        title: 'Akshardham Temple',
        location: 'Delhi',
        date: '2025',
    },
    {
        src: 'website_photos/nani1',
        title: 'Nani',
        location: 'Delhi',
        date: '2025',
    },
    {
        src: 'website_photos/nikhil_wedding',
        title: "At Nikhil & Anushree's Wedding",
        location: 'California',
        date: '2025',
    },
    {
        src: 'website_photos/sequoia_inside',
        title: 'Giant Sequoia',
        location: 'Sequoia National Park, California',
        date: '2025',
    },
    {
        src: 'website_photos/yosemite_fam',
        title: 'Yosemite Valley',
        location: 'Yosemite National Park, California',
        date: '2025',
    },
    {
        src: 'website_photos/dc_fam',
        title: 'Capitol',
        location: 'Washington D.C.',
        date: '2025',
    },
    {
        src: 'website_photos/mexico_cathedral',
        title: 'Catedral Metropolitana',
        location: 'Mexico City, Mexico',
        date: '2025',
    },
    {
        src: 'website_photos/mexico_aztecs',
        title: 'Aztec Dance',
        location: 'Mexico City, Mexico',
        date: '2025',
    },
    {
        src: 'website_photos/puerto_vallarta1',
        title: 'A Sunset in Jalisco',
        location: 'Puerto Vallarta, Mexico',
        date: '2025',
    },
    {
        src: 'website_photos/puerto_vallarta2',
        title: 'Puerto Vallarta',
        location: 'Puerto Vallarta, Mexico',
        date: '2025',
    },
    {
        src: 'website_photos/heavenly',
        title: 'Heavenly',
        location: 'Lake Tahoe, California',
        date: '2025',
    },
    {
        src: 'website_photos/cloud_forest',
        title: 'Cloud Forest',
        location: 'Singapore',
        date: '2024',
    },
    {
        src: 'website_photos/marina_bay',
        title: 'Marina Bay Sands',
        location: 'Singapore',
        date: '2024',
    },
    {
        src: 'website_photos/havelock',
        title: 'Havelock Island',
        location: 'The Andaman Islands, India',
        date: '2024',
    },
    {
        src: 'website_photos/nemo',
        title: 'I found Nemo',
        location: 'The Andaman Islands, India',
        date: '2024',
    },
    {
        src: 'website_photos/pumpkins',
        title: 'Pumpkins can be huge',
        location: 'Half Moon Bay, California',
        date: '2024',
    },
    {
        src: 'website_photos/niagara_night',
        title: 'Niagara at Night',
        location: 'Niagara Falls, New York',
        date: '2024',
    },
    {
        src: 'website_photos/niagara',
        title: "Nature's Masterpiece",
        location: 'Niagara Falls, New York',
        date: '2024',
    },
    {
        src: 'website_photos/capitol',
        title: 'Capitol',
        location: 'Washington D.C.',
        date: '2024',
    },
    {
        src: 'website_photos/praful_wedding',
        title: "Praful & Deepa's Wedding",
        location: 'Chicago',
        date: '2024',
    },
    {
        src: 'website_photos/whitewater',
        title: 'White Waters',
        location: 'American River',
        date: '2024',
    },
    {
        src: 'website_photos/poconos',
        title: 'UTV',
        location: 'Poconos, Philadelphia',
        date: '2024',
    },
    {
        src: 'website_photos/nola',
        title: 'French Quarter',
        location: 'New Orleans, Louisiana',
        date: '2024',
    },
    {
        src: 'website_photos/milkyway',
        title: 'Milky Way',
        location: 'Glacier National Park, Montana',
        date: '2024',
    },
    {
        src: 'website_photos/glacier_two_medicine',
        title: 'Two Medicine Lake',
        location: 'Glacier National Park, Montana',
        date: '2024',
    },
    {
        src: 'website_photos/glacier_lake',
        title: 'Lake McDonald',
        location: 'Glacier National Park, Montana',
        date: '2024',
    },
    {
        src: 'website_photos/homewood',
        title: 'Homewood',
        location: 'Lake Tahoe, California',
        date: '2024',
    },
    {
        src: 'website_photos/pinnacles',
        title: 'Condor Gulch Trail',
        location: 'Pinnacles National Park, California',
        date: '2024',
    },
    {
        src: 'website_photos/grand_canyon',
        title: 'Navajo Point',
        location: 'Grand Canyon, Arizona',
        date: '2023',
    },
    {
        src: 'website_photos/nyc23',
        title: 'Little Island',
        location: 'New York City',
        date: '2023',
    },
    {
        src: 'website_photos/whitecoat',
        title: "Kyra's White Coat Ceremony",
        location: 'Mare Island, California',
        date: '2023',
    },
    {
        src: 'website_photos/flatirons',
        title: 'Flatirons',
        location: 'Boulder, Colorado',
        date: '2023',
    },
    // {
    //     src: 'website_photos/lostlake',
    //     title: 'Lost Lake',
    //     location: 'Nederland, Colorado',
    //     date: '2023',
    // },
    {
        src: 'website_photos/outsidelands',
        title: 'Outsidelands',
        location: 'Golden Gate Park, San Francisco',
        date: '2023',
    },
    {
        src: 'website_photos/rainier',
        title: 'Mt. Rainier',
        location: 'Mount Rainier National Park, Washington',
        date: '2023',
    },
    {
        src: 'website_photos/lakecrescent',
        title: 'Lake Crescent',
        location: 'Olympic National Park, Washington',
        date: '2023',
    },
    {
        src: 'website_photos/hallofmosses',
        title: 'Hall of Mosses',
        location: 'Olympic National Park, Washington',
        date: '2023',
    },
    {
        src: 'website_photos/kilauea',
        title: 'Kilauea Volcano',
        location: "Volcanoes National Park, Hawai'i",
        date: '2023',
    },
    {
        src: 'website_photos/waipio',
        title: "Waipi'o Lookout",
        location: "Big Island, Hawai'i",
        date: '2023',
    },
    {
        src: 'website_photos/kahaluu',
        title: "Kahalu'u Beach",
        location: "Big Island, Hawai'i",
        date: '2023',
    },
    {
        src: 'website_photos/rome',
        title: 'A Roman Sunset',
        location: 'Rome, Italy',
        date: '2023',
    },
    {
        src: 'website_photos/florence',
        title: 'A Florentine Golden Hour',
        location: 'Florence, Italy',
        date: '2023',
    },
    {
        src: 'website_photos/napoli',
        title: 'A Neapolitan Blue Hour ft Mt. Vesuvius',
        location: 'Naples, Italy',
        date: '2023',
    },
    {
        src: 'website_photos/vatican',
        title: "Strolling by St. Peter's Basilica",
        location: 'Vatican City',
        date: '2023',
    },
    {
        src: 'website_photos/charminar',
        title: 'Charminar',
        location: 'Hyderabad, India',
        date: '2023',
    },
    {
        src: 'website_photos/family1',
        title: 'Family',
        location: 'New Delhi, India',
        date: '2023',
    },
    {
        src: 'website_photos/rashtrapati_bhavan',
        title: 'Rashtrapati Bhavan',
        location: 'New Delhi, India',
        date: '2023',
    },
    {
        src: 'website_photos/yosemite_friends',
        title: 'Yosemite',
        location: 'Yosemite National Park, California',
        date: '2022',
    },
    {
        src: 'website_photos/yosemite',
        title: 'Mist Trail',
        location: 'Yosemite National Park, California',
        date: '2022',
    },
    {
        src: 'website_photos/encinitas',
        title: 'Encinitas',
        location: 'California',
        date: '2022',
    },
    {
        src: 'website_photos/craterswim',
        title: 'Crater Lake',
        location: 'Oregon',
        date: '2022',
    },
    {
        src: 'website_photos/craterlake',
        title: 'Crater Lake',
        location: 'Oregon',
        date: '2022',
    },
    {
        src: 'website_photos/lisbon',
        title: 'Lisbon',
        location: 'Portugal',
        date: '2022',
    },
    {
        src: 'website_photos/duoro',
        title: 'Duoro River',
        location: 'Porto, Portugal',
        date: '2022',
    },
    {
        src: 'website_photos/porto',
        title: 'Porto',
        location: 'Portugal',
        date: '2022',
    },
    {
        src: 'website_photos/sagradafamilia',
        title: 'La Sagrada Familia',
        location: 'Barcelona, Spain',
        date: '2022',
    },
    {
        src: 'website_photos/tetons',
        title: 'The Tetons',
        location: 'Grand Teton National Park, Wyoming',
        date: '2021',
    },
    {
        src: 'website_photos/teton',
        title: 'By the Snake River',
        location: 'Grand Teton National Park, Wyoming',
        date: '2021',
    },
    {
        src: 'website_photos/prismatic',
        title: 'Grand Prismatic Spring',
        location: 'Yellowstone National Park',
        date: '2021',
    },
    {
        src: 'website_photos/yellowstone',
        title: 'Upper Falls',
        location: 'Yellowstone National Park',
        date: '2021',
    },
    {
        src: 'website_photos/bozeman',
        title: 'A Cottage in Bozeman',
        location: 'Bozeman, Montana',
        date: '2021',
    },
    {
        src: 'website_photos/rockies',
        title: 'The Rockies',
        location: 'Rocky Mountain National Park, Colorado',
        date: '2021',
    },
    {
        src: 'website_photos/denver',
        title: 'The Colorado State Capitol',
        location: 'Denver, Colorado',
        date: '2021',
    },
    {
        src: 'website_photos/parthenon',
        title: 'The Parthenon of Nashville',
        location: 'Nashville, Tennessee',
        date: '2021',
    },
    {
        src: 'website_photos/smokies',
        title: 'Surreal Smokies',
        location: 'Great Smoky Mountain National Park, Tennesse - North Carolina border',
        date: '2021',
    },
    {
        src: 'website_photos/charleston',
        title: 'A Charleston Sunset',
        location: 'Isle of Palms, South Carolina',
        date: '2021',
    },
    {
        src: 'website_photos/charlestonBird',
        title: 'East Coast Skies',
        location: 'Isle of Palms, South Carolina',
        date: '2021',
    },
    {
        src: 'website_photos/atlanta',
        title: 'Altanta Skyline',
        location: 'Atlanta, Georgia',
        date: '2021',
    },
    {
        src: 'website_photos/austin',
        title: 'An afternoon in Austin',
        location: 'Austin, Texas',
        date: '2021',
    },
    {
        src: 'website_photos/whitesands',
        title: 'White Sands National Park',
        location: 'New Mexico',
        date: '2021',
    },
    {
        src: 'website_photos/whitesands2',
        title: 'White Sands National Park',
        location: 'New Mexico',
        date: '2021',
    },
    {
        src: 'website_photos/hoover',
        title: 'Hoover Dam',
        location: 'Arizona-Nevada Border',
        credits: 'Ankur Papneja',
        date: '2021',
    },
    {
        src: 'website_photos/alcatraz',
        title: 'Alcatraz',
        location: 'San Francisco',
        date: '2020',
    },
    {
        src: 'website_photos/coyotePark',
        title: 'Coyote Park',
        location: 'San Mateo, CA',
        date: '2020',
    },
    {
        src: 'website_photos/notredame',
        title: 'Notre Dame',
        location: 'Paris, France',
        date: '2019',
    },
    {
        src: 'website_photos/salzburg',
        title: 'Altstadt',
        location: 'Salzburg, Austria',
        date: '2019',
    },
    {
        src: 'website_photos/eiffel',
        title: 'Eiffel Tower',
        location: 'Paris, France',
        date: '2019',
    },
    {
        src: 'website_photos/munich',
        title: 'Marienplatz',
        location: 'Munich, Germany',
        date: '2019',
    },
    {
        src: 'website_photos/grad1',
        title: 'Graduation',
        location: 'UCLA',
        credits: 'Stanley Wu',
        date: '2019',
    },
    {
        src: 'website_photos/grad2',
        title: 'Graduation',
        location: 'UCLA',
        credits: 'Stanley Wu',
        date: '2019',
    },
    {
        src: 'website_photos/ucla_commencement',
        title: 'Commencement',
        location: 'UCLA',
        credits: '',
        date: '2019',
    },
    {
        src: 'website_photos/engineers_ball',
        title: 'Engineers Ball',
        location: 'Pauley Pavilion, UCLA',
        credits: '',
        date: '2018',
    },
    {
        src: 'website_photos/lahacks',
        title: 'LA Hacks Organizing Team',
        location: 'Pauley Pavilion, UCLA',
        credits: '',
    },
    {
        src: 'website_photos/clfounders',
        title: 'UCLA Creative Labs - Founding Team',
        credits: '',
        date: '2017',
    },
    {
        src: 'website_photos/FuturizeX2',
        title: 'Futurize X',
        location: 'Powell Library, UCLA',
        credits: '',
        date: '2017',
    },
];
